import React from "react";
import siteConfig from "../../../data/SiteConfig.js";

/** @jsx jsx */
import { Styled, jsx } from "theme-ui";

import Tech from "./Tech.jsx";


const Technologies = () => {
  const { technologyStak } = siteConfig;

  return (
    <div
      sx={{
        width: "100%",
        backgroundColor: ""
      }}
    >
      <p
        sx={{
          fontWeight: "bold"
        }}
      >
        I love working with
      </p>
      <div 
        sx={{
          margin: "auto",
          paddingY: "3rem",
          maxWidth: "calc(300px + 4rem)",
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr ",
          gridTemplateRows: "repeat(3, 100px)",
          gap: "2rem",
          alignItems: "center",
          justifyItems: "center"
        }}
      >
        {

          technologyStak.map((technology) => (
            <Tech technology={technology}/>
          ))
        }
      </div>
    </div>
  )
}

export default Technologies;
